import * as React from 'react';

import {CueCard} from 'shells/cue-card/cue-card';
import {Illustration} from 'shells/illustrations/illustration';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {QuoteAndInvoiceInfoModal} from 'shells/modal/quote-and-invoice-info-modal';
import {Body} from 'shells/typography/body';

import {useGetQuoteTemplate} from '../../../lead/sales-documents/quotes/graphql/hooks';
import {QuoteWrapper} from '../../../lead/sales-documents/quotes/quote-wrapper';

import {appHistory} from '../../../../history';

import {convertTemplateToQuote} from '../shared/helper';

import styles from './quote-template-page.module.css';

export function QuoteTemplatePage() {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isCardMinimized, setIsCardMinimized] = React.useState(false);

    const {quoteTemplate, isLoading} = useGetQuoteTemplate();

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <div className={styles['quote-template-container-outer']}>
            {!isCardMinimized && (
                <div className={styles['cue-card-container']}>
                    <CueCard
                        title='Create snazzy quotes with one click'
                        description='Customize the basic details of your quotes within Quote templates, making it easy to generate quotes directly from your lead page.'
                        thumbnailIllustration={<Illustration src='simple-quote' />}
                        thumbnailBackgroundColor='plumLt'
                        withBookmarkIcon={true}
                        history={appHistory}
                        cta={{
                            text: 'Learn more',
                            actionType: 'modal',
                            onClick: () => setIsModalOpen(true),
                        }}
                        onMinimize={() => setIsCardMinimized(true)}
                    />
                </div>
            )}
            <div className={styles['quote-template-header']}>
                <Body isBold={true} size={'large'}>
                    Quote defaults
                </Body>
            </div>
            <div className={styles['quote-template-container-inner']}>
                <QuoteWrapper
                    quote={convertTemplateToQuote(quoteTemplate)}
                    isTemplate={true}
                    toggleHasActiveSection={() => {}}
                />
            </div>
            {isModalOpen && (
                <QuoteAndInvoiceInfoModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </div>
    );
}
